import { Route, RouteComponentProps, RouteProps } from 'react-router-dom';

import { ProjectProvider } from '../../common/useProject';
import { encodeUrl } from '../../common/helpers';
import { isSupportedLocale } from '../../i18n';
import { useSession } from '../Auth/SessionProvider';
import BrowserRedirect from './BrowserRedirect';
import LocaleProvider from '../../common/LocaleProvider';
import config from '../../config';

interface ProjectRouteProps extends RouteProps {
  render(route: RouteComponentProps<any>): any;
}

const ProjectRoute = ({ path, render, ...rest }: ProjectRouteProps) => {
  const { user } = useSession();

  if (!user) {
    return <BrowserRedirect to={`/login?${encodeUrl({ returnUrl: window.location.href })}`} />;
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        const { projectId } = props.match.params;
        const project = user.project_memberships.filter(
          (membership) => membership.project.id === projectId,
        )[0]?.project;

        if (!project) {
          return <BrowserRedirect to="/me" />;
        }

        const locale = isSupportedLocale(user.locale) ? user.locale : config.fallbackLocale;

        return (
          <LocaleProvider
            currency={project.currency}
            timezone={project.timezone}
            locale={locale}
            localizeRequests={false}
          >
            <ProjectProvider project={project}>
              {render(props)}
            </ProjectProvider>
          </LocaleProvider>
        );
      }}
    />
  );
};

export default ProjectRoute;
